import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams  } from '@angular/common/http';
import { Observable } from 'rxjs';

import * as theGlobals from '../shared/globals';

@Injectable()
export class NoticeService {

    private myUrl = theGlobals.setEnv().funcUrl;

    constructor(private http: HttpClient) { }

    // get list of label candidates (UI will allow user to exclude duplicates)
    getNoticeLabels(hearingId: string, noticeType: string): Observable<any> {
      let xUrl = this.myUrl + '/notices/labels/hearing/' + hearingId + '/' + noticeType;
      return this.http.get<any>(xUrl);
    }

    // get PDF (stream) of selected labels to print
    getSelectedLabels(myLabels: any): Observable<Blob> {
      let xUrl = this.myUrl + '/notices/generateselectedlabels';
      // return this.http.post(xUrl, myLabels);
      return this.http.post(xUrl, myLabels,{ responseType: 'blob' });
    }

    // get list of notices for specified type, hearing date, etc...
    getNoticesGen(prtType: string, objId: string, subType: string): Observable<any> {
        let xUrl = this.myUrl;
        if (prtType === 'NH') {
            // page containing list of notices scheduled for a specified Hearing date
            xUrl = xUrl + '/notices/' + objId;
        } else if (prtType === 'NL') {
            // list of notices for future dates
            xUrl = this.myUrl + '/notice/info';
        }
        return this.http.get<any>(xUrl);
    }

    updateNoticeStatuses(hearingId: string, noticeType: string): Observable<any> {
        // const xUrl = this.myFuncUrl + '/hearingstatus/' + hearingId + '/' + noticeType;
        const xUrl = this.myUrl + '/hearing/generate/status/' + hearingId + '/' + encodeURIComponent(noticeType);
        // const xUrl = this.myUrl + '/case/generate-new-status/' + hearingId + '/' + encodeURIComponent(noticeType)
        return this.http.get<any>(xUrl, { headers: this.getCORSHeader()});
    }

    // generate Notices PDF
    getPrintNoticesPdf(hearingId: string, noticeType: string): Observable<Blob>
    {
      let xUrl = this.myUrl + '/notices/' + hearingId + '/' + noticeType;
      // return this.http.post(xUrl, myLabels);
      return this.http.get(xUrl,{ responseType: 'blob' });
    }

    getCORSHeader(): HttpHeaders {
        let headers = new HttpHeaders();

        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');

        //headers.append('Access-Control-Allow-Origin', 'http://localhost:4200');
        //headers.append('GET', 'POST');

        return headers;
    }

    private handleError(err: HttpErrorResponse) {
        // in a real world app, we may send the error to some remote logging infrastructure
        // instead of just logging it to the console
        let errorMessage = '';
        const status = err.status;
        if (err.error instanceof Error) {
            // A client-side or network error occurred. Handle it accordingly.
            errorMessage = `An error occurred: ${err.error.message}`;
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
        }
        console.error(errorMessage);
        return Observable.throw(status);
    }

}
